// read env file
const dotenv = require('dotenv');
dotenv.config();

import './axios'
import './vee-validate'
import './moment'
import './filters'
